export default __webpack_public_path__ + "static/media/GoldenBoy.20c83415.jpg";